export enum McpStep {
  SelectApp = 'SelectApp',
  Details = 'Details',
}

export const mcpStepTitleMap = {
  [McpStep.SelectApp]: 'Select app',
  [McpStep.Details]: 'MCP details',
};

export const mcpSteps = [McpStep.SelectApp, McpStep.Details];
